import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=6c8badec&scoped=true"
import script from "./qrcode.vue?vue&type=script&lang=js"
export * from "./qrcode.vue?vue&type=script&lang=js"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=6c8badec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8badec",
  null
  
)

export default component.exports